import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import DeletePop from "../../constants/ErrorPermissionModal";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
const ActionDropBar = ({
  title,
  handleDelete,
  handleCopy,
  active,
  setActive,
  sub,
  index,
  handleup,
  handledown,
  handleEdit,
  status,
  handleStatus,
  slug,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        alignItems: "center",
        borderBottom: "1px solid lightgray",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div
          onClick={() => setActive(!active)}
          style={{
            border: "2px solid black",
            borderRadius: "100px",
            cursor: "pointer",
          }}
        >
          {active ? <ArrowDropUpIcon></ArrowDropUpIcon> : <ArrowDropDownIcon />}
        </div>{" "}
        <div
          style={{
            display: "flex",
            fontWeight: "bold",
          }}
        >
          <div
            className="datatite"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </div>{" "}
      </div>{" "}
      <div
        style={{
          display: "flex",
          fontWeight: "bold",
        }}
      >
        {handleup && (
          <div
            style={{
              display: "flex",
              alignItems: "center",

              marginRight: "10px",
            }}
          >
            {slug === "faq" && (
              <FormControlLabel
                control={
                  <Switch
                    checked={status}
                    onChange={(e) => handleStatus(index)}
                    color="success"
                  />
                }
              />
            )}
            <div
              style={{
                cursor: "pointer",
                color: "#9f9f9f",
                marginLeft: "20px",
              }}
              onClick={() => handleup(index)}
            >
              <ArrowCircleUpIcon style={{ color: "red", fontSize: 28 }} />
            </div>
            <div
              style={{
                cursor: "pointer",
                color: "#9f9f9f",
                marginRight: "20px",
              }}
              onClick={() => handledown(index)}
            >
              <ArrowCircleDownIcon style={{ color: "green", fontSize: 28 }} />
            </div>
          </div>
        )}
        {sub && (
          <div style={{ cursor: "pointer" }} onClick={handleEdit}>
            <EditIcon />
          </div>
        )}
        {handleCopy && (
          <button
            type="button"
            style={{
              cursor: "pointer",
              background: "none",
              border: "none",
              padding: 0,
              marginRight: "8px",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => handleCopy(index)}
            title="Copy"
          >
            <AddCircleOutlineIcon style={{ color: "#1976d2", fontSize: 28 }} />
          </button>
        )}
        <div style={{ cursor: "pointer", color: "#9f9f9f" }}>
          <DeletePop onConfirm={handleDelete}>
            {" "}
            <DeleteIcon style={{ color: "#9f9f9f" }} />
          </DeletePop>
        </div>
      </div>
    </div>
  );
};

export default ActionDropBar;
